// extracted by mini-css-extract-plugin
export default {"main":"main_main__ZYQi0","fade-in":"main_fade-in__C1S0W"};